module.exports = __webpack_public_path__ + "static/media/logo.7d2e3c0f.svg";